import api from "@helpers/api";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_TYPE}/budget/year`;

export const getBudgetYearListData = (() => {
  return async (queries?: any): Promise<{ data: any }> => {
    return api
      .get(`${apiEndPoint}`, {
        params: {
          page: 1,
          size: 1000000,
          ...queries,
        },
      })
      .then((response) => {
        return { data: response.data };
      });
  };
})();
